module.exports = __webpack_public_path__ + "8d9823806d6eae386ad3cb7525d4302d.svg";